class Bridge {


    constructor() {
        this.cardCallbacks = {}
        this.updateControlCallbacks = []

        // колбэки для изменения контекста в DogContext
        this.updateDogCtxDogList = null
        this.updateDogCtxObjList = null
        this.updateDogCtxPntList = null

        this.isRestoreMode = false;
    }

    needToSave() {
        return !this.isRestoreMode
    }

    buildRequestArgs(uData) {
        const args = {
            dog_ctx: {},
            net_ctx: {},
        }
        if (uData.who_id) {
            const parts = uData.who_id.split(':');
            if (parts[1] === 'e') {
                args.emp_id = parts[0];
            }
            if (parts[1] === 'd') {
                args.dep_id = parts[0];
            }
        }
        if (uData.where_id) {
            const parts = uData.where_id.split(':');
            if (parts[0] === 't') {
                args.tab_id = parts[2];
            }
            if (parts[0] === 'g') {
                args.grp_id = parts[1];
            }
        }
        if (uData.beg) args.beg = uData.beg;
        if (uData.end) args.end = uData.end;

        if (uData.dog_ctx_dep_id) args.dog_ctx.dep_id = uData.dog_ctx_dep_id;
        if (uData.dog_ctx_dog_id) args.dog_ctx.dog_id = uData.dog_ctx_dog_id;
        if (uData.dog_ctx_obj_id) args.dog_ctx.obj_id = uData.dog_ctx_obj_id;
        if (uData.dog_ctx_pnt_id) args.dog_ctx.pnt_id = uData.dog_ctx_pnt_id;

        return args;
    }

    // добавляет колбэк обновления контрола при изменении userData
    addUpdateControlCallback(cb) {
        this.updateControlCallbacks.push(cb)
    }

    onChange() {
        console.log('HistoryBridge onChange')
    }

    // вызовы колбэков при изменении userData
    updateControls(data) {
        // console.log(`HistoryBridge:updateControls count: ${this.updateControlCallbacks.length} `);

        this.updateControlCallbacks.forEach((cb) => {
            cb(data)
        });
    }

    // событие изменения контекста филиала в DogContext
    // для отработки списка договоров 
    async onChangeDepInDogContext(depId) {
        if (this.updateDogCtxDogList) {
            await this.updateDogCtxDogList(depId)
        }
    }

    // событие изменения контекста договора в DogContext
    // для отработки списка объектов 
    async onChangeDogInDogContext(dogId) {
        if (this.updateDogCtxObjList) {
            await this.updateDogCtxObjList(dogId)
        }
    }

    // событие изменения контекста объекта в DogContext
    // для отработки списка ТУ 
    async onChangeObjInDogContext(objId) {
        if (this.updateDogCtxObjList) {
            await this.updateDogCtxPntList(objId)
        }
    }

    async onChangePntInDogContext(pntId) {
        console.log('history-bridge:onChangePntInDogContext', pntId)
    }

    // обновление грида истории  
    updateResult(rows) {
        console.log('HistoryBridge:updateResult', this.resultsRef)
        if (this.resultsRef) {
            this.resultsRef.value = rows
        }
    }

    debug(args) {
        console.log(args)
    }

    hello() {
        console.log('Hello from Bridge')
    }

}

const bridge = new Bridge()
export { bridge }
